import {deserialize} from 'libs/cerialize';

export class GenericButtonModel {
    @deserialize
    Id: number;

    @deserialize
    Name: string;
}